import { FieldConfig } from '../../common/field-types';
import {
  GENDER_OPTIONS,
  LifeMaxFormValues,
  RECOMMENDED_RATE_FROM_2028,
  RECOMMENDED_RATE_UNTIL_2027,
} from './schema';

export const LIFE_MAX_FIELDS: readonly FieldConfig<LifeMaxFormValues>[] = [
  { key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date' },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS,
  },
  {
    key: 'initial_contribution',
    label: 'Prima única (contribución inicial) ',
    kind: 'number',
    hint: 'UF (mínimo 3.000 = 1.500 básica + 1.500 exceso)',
  },
  {
    key: 'death_insured_capital',
    label: 'Capital fallecimiento',
    kind: 'number',
    hint: 'UF (mínimo: max(150, 1,5% de la prima única). Máximo 20.000 (<66 años) o 2.500 (≥66)).',
  },
  {
    key: 'projection_rate',
    label: 'Tasa de proyección',
    kind: 'number',
    hint: `Anual real. Preset tasa fija: ${RECOMMENDED_RATE_UNTIL_2027 * 100}% hasta dic-2027, ${RECOMMENDED_RATE_FROM_2028 * 100}% desde ene-2028. Máximo 5%.`,
    step: 0.001,
  },
  {
    key: 'unscheduled_annual_contribution',
    label: 'Aporte anual extra',
    kind: 'number',
    hint: 'UF (depósito anual no pactado en cada aniversario).',
  },
];
